/**
 * Created by Rodrigo Quesada on 03/05/17.
 */
import {Model, ModelMixin} from '../../../domain/model/common/model.class';
import {User} from '../../../domain/model/user/user.model';
import {Profile} from '../../../domain/model/profile/profile.model';
import {ReleaseAuthorization} from '../../../domain/model/release/release-authorization.model';
import ProjectionInformation = Model.ProjectionInformation;

export class ReleaseAuthorizationInfo extends ModelMixin() implements Model<ReleaseAuthorizationInfo> {

    TYPE = ReleaseAuthorizationInfo;
    static projectionInformation = new ProjectionInformation('releaseAuthorizationInfo');

    user: User = new User();
    releaseAuthorization: ReleaseAuthorization = new ReleaseAuthorization();
    profile: Pick<Profile, 'ssn'> = new Profile();

    constructor(jsonData: any = {}) {
        super();
        this.user = new User(jsonData.user);
        this.releaseAuthorization = new ReleaseAuthorization(jsonData.releaseAuthorization);
        this.profile = new Profile(jsonData.profile);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/release/model/release-authorization-info.model.ts